export default "assets/images/line-fullwidth-image-bd38c112.svg";